export const SearchIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.81482 1.77778C4.03294 1.77778 1.77778 4.03294 1.77778 6.81482C1.77778 9.59669 4.03294 11.8519 6.81482 11.8519C9.5967 11.8519 11.8519 9.59669 11.8519 6.81482C11.8519 4.03294 9.5967 1.77778 6.81482 1.77778ZM0 6.81482C0 3.0511 3.0511 0 6.81482 0C10.5785 0 13.6296 3.0511 13.6296 6.81482C13.6296 8.37624 13.1045 9.81501 12.2212 10.9642L15.7396 14.4826C16.0868 14.8297 16.0868 15.3925 15.7396 15.7396C15.3925 16.0868 14.8297 16.0868 14.4826 15.7396L10.9641 12.2212C9.815 13.1045 8.37623 13.6296 6.81482 13.6296C3.0511 13.6296 0 10.5785 0 6.81482Z"
        fill="currentColor"
      />
    </svg>
  )
}
